import { Modal } from '../../modules/modal.js';

window.app = window.app || {};
app.site = app.site || {};

app.site.tracking = {
    init: () => {
        app.site.tracking.build();
    },
    build: () => {
        const cookie = app.helpers.cookie.get('paCookiesOther');
        if (cookie !== 'yes') return;

        document.querySelectorAll('script[data-cookie-consent="paCookiesOther"]').forEach(script => {
            const s = document.createElement('script');
            if (script.dataset.src) {
                s.src = script.dataset.src;
                s.async = script.async;
            } else {
                s.textContent = script.textContent;
            }
            // Copy attributes if needed (optional)
            Array.from(script.attributes).forEach(attr => {
                if (!['type', 'data-cookie-consent', 'data-src'].includes(attr.name)) {
                    s.setAttribute(attr.name, attr.value);
                }
            });
            // Replace in place
            script.parentNode.replaceChild(s, script);
        });
    }
};